import * as React from "react";
import { Gapped, Input, Select } from "react-ui";

import { Caption, Row } from "../../FiasFnsManualEditor.styles";
import { getHouseTypeLongName } from "../../../../FiasInput/Utils/Convertations/House/House";
import { getBuildingItems } from "../FiasFnsManualEditorUtils";

interface HouseProps {
    type: string | undefined;
    number: string | undefined;
    onTypeChange: (next: string) => void;
    onNumberChange: (next: string) => void;
}

export function House({ type, number, onTypeChange, onNumberChange }: HouseProps): JSX.Element | null {
    const buildingItems = getBuildingItems(type);

    return (
        <Row>
            <Caption>Номер здания / сооружения</Caption>
            <Gapped>
                <Select<string | undefined, string>
                    width={80}
                    value={getHouseTypeLongName(type) || type || undefined}
                    onValueChange={next => onTypeChange(next ?? "")}
                    placeholder={"Тип"}
                    data-tid={"HouseType"}
                    items={buildingItems}
                />
                <Input
                    width={80}
                    maxLength={255}
                    value={number ?? ""}
                    placeholder={"Номер"}
                    data-tid={"HouseNum"}
                    onValueChange={next => onNumberChange(next)}
                />
            </Gapped>
        </Row>
    );
}
